import config from '../config/application';
import { apiCall } from "./common/oauth.service"
const society = 'find_by_user';

class SocietyService {

    getSociety(json) {
        const url = `${config.data.providers.society.url}/${society}`;
        return apiCall('post', url, json);
    }
}

export default new SocietyService(); 